import * as React from 'react';
import Calendar from 'react-calendar';
import Icon from '../icon';
import { Styled } from './style';
var StyledCalendar = function (_a) {
    var activeStartDate = _a.activeStartDate, onMouseUp = _a.onMouseUp, onMouseDown = _a.onMouseDown, callback = _a.callback, value = _a.value, minDate = _a.minDate, maxDate = _a.maxDate, selectRange = _a.selectRange, locale = _a.locale;
    return (React.createElement(Styled, { className: "events-wrapper", onMouseDown: onMouseDown, onMouseUp: onMouseUp },
        React.createElement(Calendar, { activeStartDate: activeStartDate, onChange: callback, value: value, selectRange: selectRange, minDate: minDate, maxDate: maxDate, minDetail: "month", maxDetail: "month", locale: locale !== null && locale !== void 0 ? locale : 'en-US', nextLabel: React.createElement(Icon, { name: "arrow-right" }), prevLabel: React.createElement(Icon, { name: "arrow-left" }) })));
};
Object.assign(StyledCalendar, {
    displayName: 'Calendar',
});
export default StyledCalendar;
//# sourceMappingURL=index.js.map